import { fromJS, Map, List } from 'immutable';

import Activity from 'models/ActivityModel';
import ActivityGroup from 'models/ActivityGroup';
import FundingDocument from 'models/FundingDocumentModel';

import { createReducer } from '../utils/helpers';
import { generateReducer } from '../utils/HttpReducerHelper';

import {
  fundingSearchActivities,
  triggerActivityAction,
  dismissActivity,
  uploadDocuments,
  removeDocument,
  completeActivity,
  OPEN_COLLECTIVE_ACTIVITIES_MODAL,
  CLOSE_COLLECTIVE_ACTIVITIES_MODAL,
  COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED,
  collectiveActivities,
} from './types';
export * from './actions';

const initialState = fromJS({
  byId: {},
  timeline: {
    ids: [],
    network: { loading: false, error: false },
  },
  collectiveActivities: {
    fundingSearches: [],
    modalOpen: false,
    filters: [],
    network: { loading: false, error: false },
  },
});

const fundingSearchActivitiesReducer = generateReducer('timeline', Activity.deserialize);

const requestCollectiveActivitiesSuccessReducer = (state, action) => {
  const fundingSearches = action.response.map((fundingSearch) =>
    ActivityGroup.deserialize({
      ...fundingSearch,
      activities: List(fundingSearch.activities.map((activity) => activity.id)),
    }),
  );
  const activitiesMap = action.response.reduce(
    (acc, fundingSearch) =>
      fundingSearch.activities.reduce(
        (innerAcc, activity) => innerAcc.set(activity.id, Activity.deserialize(activity)),
        acc,
      ),
    Map(),
  );

  return state.withMutations((s) =>
    s
      .setIn(['collectiveActivities', 'network', 'loading'], false)
      .setIn(['collectiveActivities', 'network', 'error'], false)
      .setIn(['collectiveActivities', 'fundingSearches'], List(fundingSearches))
      .mergeIn(['byId'], activitiesMap),
  );
};

export default createReducer(initialState, {
  [fundingSearchActivities.request]: fundingSearchActivitiesReducer.request,
  [fundingSearchActivities.success]: fundingSearchActivitiesReducer.success,
  [fundingSearchActivities.failure]: fundingSearchActivitiesReducer.failure,

  [triggerActivityAction.success]: (state, action) =>
    state.setIn(['byId', action.activityId], Activity.deserialize(action.response)),

  [dismissActivity.success]: (state, action) =>
    state.setIn(['byId', action.activityId], Activity.deserialize(action.response)),

  [uploadDocuments.success]: (state, action) =>
    state.mergeIn(
      ['byId', action.activityId, 'documents'],
      action.documents.map((document) => FundingDocument.deserialize(document)),
    ),

  [removeDocument.success]: (state, action) =>
    state.updateIn(['byId', action.activityId, 'documents'], (documents) =>
      documents.filter((doc) => doc.id !== action.documentId),
    ),

  [completeActivity.success]: (state, action) =>
    state.mergeIn(['byId', action.activityId], Activity.deserialize(action.response)),

  [OPEN_COLLECTIVE_ACTIVITIES_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['collectiveActivities', 'modalOpen'], true)
        .setIn(['collectiveActivities', 'filters'], fromJS(action.filters || [])),
    ),
  [CLOSE_COLLECTIVE_ACTIVITIES_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['collectiveActivities', 'modalOpen'], false)
        .setIn(['collectiveActivities', 'filters'], List()),
    ),

  [COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED]: (state, action) =>
    state.setIn(['collectiveActivities', 'filters'], List(action.filters || [])),

  [collectiveActivities.request]: (state) =>
    state.setIn(['collectiveActivities', 'network', 'loading'], true),
  [collectiveActivities.success]: requestCollectiveActivitiesSuccessReducer,
  [collectiveActivities.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['collectiveActivities', 'network', 'loading'], false)
        .setIn(['collectiveActivities', 'network', 'error'], action.error),
    ),
});
